/**
 * "Ajouter des photos" button floating at the bottom of the prints column.
 * Added to the board itself, not to its scrolled content, so it stays put while the prints scroll.
 */
fx.ns("desktop.print", class AddPhotosFab extends fx.Component {

    onReady()
    {
        super.onReady();

        this._button = this.find(".fl-add-fab");
        this._updateDisabled();
    }

    render()
    {
        return '<button type="button" class="fl-add-fab">' +
                    '<svg class="fl-add-fab__icon" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                        '<path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3z"/>' +
                        '<path d="M12 10v6M9 13h6"/>' +
                    '</svg>' +
                    '<span>' + fx.text("Ajouter des photos") + '</span>' +
                '</button>';
    }

    // a real disabled attribute rather than fx's enable() / disable(), which show() resets
    get disabled()
    {
        return !!this._disabled;
    }

    set disabled(val)
    {
        this._disabled = val;
        this._updateDisabled();
    }

    _updateDisabled()
    {
        if (this._button)
            this._button.disabled = this.disabled;
    }
});
